
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class Template extends Vue {
  @Prop({ default: () => [], type: Array })
  data: any;
  @Prop({ default: "", type: String })
  propName: string;
}
